// extracted by mini-css-extract-plugin
export default {"pageOverlay":"sC6a41z","side":"uZHyLwH","fadeIn":"e2IGvnt"};